import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/web/components/ui/button";
import { useCart } from "@/lib/cart";
import { formatNzd } from "@/lib/utils";

export default function Cart() {
  const { items, subtotalCents, count } = useCart();

  return (
    <>
      <Helmet><title>Cart | Cool Wave</title></Helmet>
      <section className="container py-14">
        <h1 className="mb-6 text-3xl font-bold">Your cart</h1>

        {count === 0 ? (
          <div className="rounded-xl border border-dashed border-border p-10 text-center">
            <ShoppingCart className="mx-auto mb-4 h-10 w-10 text-body/40" />
            <p className="mb-4 text-body">Your cart is empty.</p>
            <Button asChild><Link to="/products">Browse products</Link></Button>
          </div>
        ) : (
          <div className="grid gap-8 md:grid-cols-[1fr,320px]">
            <ul className="divide-y divide-border">
              {items.map((i) => (
                <li key={i.productId} className="flex items-center justify-between gap-4 py-4">
                  <div>
                    <div className="font-medium text-ink">{i.name}</div>
                    <div className="text-sm text-body">Qty {i.qty}</div>
                  </div>
                  <div className="font-semibold text-ink">{formatNzd(i.priceCents * i.qty)}</div>
                </li>
              ))}
            </ul>
            <aside className="h-fit rounded-xl border border-border p-6">
              <div className="mb-4 flex items-center justify-between text-sm">
                <span>Subtotal</span>
                <span className="font-semibold">{formatNzd(subtotalCents)}</span>
              </div>
              <Button asChild className="w-full"><Link to="/checkout">Checkout</Link></Button>
            </aside>
          </div>
        )}
      </section>
    </>
  );
}
